import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DocumentLibrary from './DocumentLibrary';

const DocumentsRouter = () => {
  return (
    <Routes>
      <Route index element={<DocumentLibrary />} />
    </Routes>
  );
};

export default DocumentsRouter;
